import React, {useEffect} from "react";
import {useAnalytics} from "@unibuddy/tracking";

import {TrackEvents, SignUpSources} from "ubcommunity-shared/src/constants";
import {Routes} from "ubcommunity-shared/src/constants/routes";
import {LandingV2} from "ubcommunity-shared/src/Auth/LandingV2";
import useRelativeRouter from "ubcommunity-shared/src/Navigation/useRelativeRouter/useRelativeRouter";

export function SharedLandingV2({source, inviteId}: {source: SignUpSources; inviteId: string}) {
    const {trackEvent} = useAnalytics();
    const {push} = useRelativeRouter();

    useEffect(() => {
        trackEvent(TrackEvents.WELCOME_PAGE_OPENED, {
            source: source || "university",
        });
    }, [trackEvent, source]);

    const handleSubmit = () => {
        push(`${Routes.SIGNUP_STEP_1}?source=${source}&inviteId=${inviteId}`);
    };

    return (
        <LandingV2 personalisedInviteId={inviteId} source={source} handleSubmit={handleSubmit} />
    );
}
